// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Clientes_BuscaPorTelefoneInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /clientes/busca_por_telefone
 *
 * Validates phone number search requests.
 */
import { registerContract } from './validate'

export interface Clientes_BuscaPorTelefoneInput {
telefone: string
}

registerContract('Clientes_BuscaPorTelefoneInput', {
  telefone: { type: 'string',  required: true },
})
